import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from 'react-bootstrap-modal';

import {Form, ErrorContainer} from 'form';

import ModalBecomeXXL from 'components/modals/ModalBecomeXXL';
import ModalFaqBlock from 'components/faq/ModalFaqBlock';

import '../../sass/modals/modalBlacklist.scss';

import {t} from 'l10n';

import {blackListUser, unBlackListUser} from 'reducers/member';

import {profileBlacklisted, profileUnblacklisted} from 'reducers/profile';


class ModalBlacklist extends Component {

    constructor(props) {
        super(props);

        this.state = {};

        this.onBlacklistSubmit = this.onBlacklistSubmit.bind(this);
        this.onUnblacklistSubmit = this.onUnblacklistSubmit.bind(this);
    }

    onBlacklistSubmit(formData, setErrors) {
        const { 
            user, 
            closeFn,
            dispatch,
        } = this.props;

        const {
            type,
            reason
        } = formData;

        let action = blackListUser(user.id, user, reason, type);

        dispatch(action);

        action.promise
            .then(() => {
                closeFn();
                dispatch(profileBlacklisted(user.id));
            })
            .catch((error) => {
                setErrors(error.messages || error.message);
            });
    }

    getBlacklistBody({user, closeFn}) {
        return (
            <Modal.Body>
                <div className="close" onClick={closeFn}/>

                <h1 className="modal-title">{t('Block %1', user.nick)}</h1>

                <div className="form">
                    <Form onSubmit={this.onBlacklistSubmit}>
                        <ErrorContainer data-errorcontainer={true} />

                        <div className="form-group">
                            <label className="mini">{t('Why would you add to your black list %1?', user.nick)}</label>
                            <textarea name="reason"/>
                        </div>
                        <div className="form-group">
                            <label className="mini">{t('For how long?')}</label>
                            <div className="selects">
                                <div className="radio">
                                    <input type="radio" id="select1" name="type" value="24h" defaultChecked={true}/>
                                    <label htmlFor="select1">{t('For 24 hours')}</label>
                                </div>
                                <div className="radio">
                                    <input type="radio" id="select2" name="type" value="permanent"/>
                                    <label htmlFor="select2">{t('Permanent')}</label>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="buttons">
                                <button className="block">{t('Block', user.nick)}</button>
                                <button type="button" className="cancel" onClick={closeFn}>{t('Cancel')}</button>
                            </div>
                        </div>

                        <div className="form-group">
                            <ModalFaqBlock items={[
                                t('If you block a user he will not be able to read your messages, watch your video and send you messages.'),
                                t('Do not block without a reason!')
                            ]}/>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
        )
    }

    onUnblacklistSubmit(formData, setErrors) {
        const { 
            user, 
            closeFn,
            dispatch,
            profileBlacklisted, 
        } = this.props;

        const {
            type,
            reason
        } = formData;

        let action = unBlackListUser(user.id);

        dispatch(action);

        action.promise
            .then(() => {
                closeFn();
                dispatch(profileUnblacklisted(user.id));
            })
            .catch((error) => {
                setErrors(error.messages || error.message);
            });
    }


    getUnblacklistBody({user, closeFn}) {
        return (
            <Modal.Body>
                <div className="close" onClick={closeFn}/>

                <h1 className="modal-title">{t('Unblock %1', user.nick)}</h1>

                <div className="form">
                    <Form onSubmit={this.onUnblacklistSubmit}>
                        <ErrorContainer data-errorcontainer={true} />

                        <input type="hidden" name="id" value={user.id}/>

                        <div className="form-group">
                            <label className="mini">{t('Do you want to unblock %1?', user.nick)}</label>

                            <div className="buttons">
                                <button className="block">{t('Unblock', user.nick)}</button>
                                <button type="button" className="cancel" onClick={closeFn}>{t('Cancel')}</button>
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
        )
    }

    render() {
        let {show, closeFn, blacklistedByMe, currentUser} = this.props;

        if (!show) return null;

        if (!currentUser.isXXL()) {
            return <ModalBecomeXXL show={show} closeFn={closeFn}/>
        }

        return (
            <Modal className="modalBlacklist" show={show} onHide={closeFn}>
                {!blacklistedByMe ? this.getBlacklistBody(this.props) : this.getUnblacklistBody(this.props)}
            </Modal>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser
    }),
    null
)(ModalBlacklist);


// WEBPACK FOOTER //
// ./src/components/modals/ModalBlacklist.js